module.exports = __webpack_public_path__ + "media/23.12d1378c.wav";